import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Custom hook to handle notifications passed via route state
 * @returns {Object} { notification, handleNotificationClose }
 */
export const useNotificationFromRoute = () => {
    const location = useLocation()
    const [notification, setNotification] = useState({
        open: false,
        message: '',
        severity: 'success'
    })

    // Check for notification data passed from navigation
    useEffect(() => {
        if (location.state?.notification) {
            setNotification({
                open: true,
                message: location.state.notification.message,
                severity: location.state.notification.severity
            })

            // Clear the state so it doesn't show again on refresh/navigation
            window.history.replaceState({}, document.title)
        }
    }, [location.state])

    const handleNotificationClose = () => {
        setNotification(prev => ({ ...prev, open: false }))
    }

    return { notification, handleNotificationClose }
}

